import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder,FormGroup, FormControl,Validators } from '@angular/forms';
import { AuthService } from '../services/auth.service';
import { ActivatedRoute } from '@angular/router';
import {AppSettings} from '../settings';
 

@Component({
  selector: 'app-autologin',
  templateUrl: './autologin.component.html',
  styles: ['./autologin.component.css'],
  encapsulation:ViewEncapsulation.None,
})
export class AutoLoginComponent {
 
  constructor(private route: ActivatedRoute,private _authService: AuthService,private formBuilder: FormBuilder) { 
       window.location.href=AppSettings.REDIRECT_LOGIN;

 
  }

    

}
